module.exports = __webpack_public_path__ + "static/img/Bachelor_010829.d375fb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010829.jpg
// module id = 259
// module chunks = 0